import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b514e6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-wrap-out" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-model" }, null, -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "card-type"
}
const _hoisted_10 = { class: "card-name" }
const _hoisted_11 = { class: "card-gender" }
const _hoisted_12 = { class: "card-brith" }
const _hoisted_13 = { class: "card-create" }
const _hoisted_14 = {
  key: 0,
  class: "card-validityPeriod"
}
const _hoisted_15 = { class: "card-issuingAuthority" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_17 = [
  _hoisted_16
]

import { computed, withDefaults, ref, onMounted, watch } from 'vue'
import type { CardItemType } from '@/types/my-credentials'
import { getRenderOperatperCanvas } from '@/compositions/my-crendentials/index'
import noActiveCard from '@/assets/my-credentails/credentails/no_active.png'
import cameraIcon from '@/assets/my-credentails/camera-arrow.svg'
import reviewIcon from '@/assets/my-credentails/review-icon.svg'
import noUserPhoto from '@/assets/my-credentails/credentails/no_user_photo.svg'
import { getBackgroundHandle, getColorHandle, getHorn } from '@/compositions/my-crendentials/index'
import { resizeInit } from '@/compositions/useWindowResize'
import {
  judgeIsNewUavOperatorCertificate,
  judgeCetifateIsDiaoyunOperater,
} from '@/compositions/my-crendentials/index'

import { defineComponent } from 'vue'
const __default__ = defineComponent({
  components: {},
  name: 'card-item',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    cardItem: null,
    photo: null,
    status: null,
    height: null,
    isActive: { type: Boolean },
    scale: null,
    needCalc: { type: Boolean }
  },
  emits: ["upload"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'upload'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { cardItem: CardItemType, photo: string | null, status: number, height?: string, isActive?: boolean, scale?: number, needCalc?: boolean };




const scaleValue = ref(0.60348)
const cardItemVm = ref<any>()
const canvasRenderImageUrl = ref('')

// const isCanOperate = computed(()=> {
//   return statusValue.value === 2
// })
const canUploadStatuds = [0, 3, 4]
const statusValue = computed(() => {
  return props.status
})
const isDiaoyunOperator = computed(() => {
  return judgeCetifateIsDiaoyunOperater(props.cardItem)
})
const isShowCamera = computed(() => {
  return canUploadStatuds.includes(statusValue.value)
})

const isShowReview = computed(() => {
  return statusValue.value === 1
})

const isShowNoUserPhoto = computed(() => {
  return statusValue.value !== 2
})
const renderImageSrc = computed(() => {
  return props.cardItem?.license_seal_image_url || props.cardItem?.license_image_url
})
const isNewUavOperateItem = computed(() => {
  return judgeIsNewUavOperatorCertificate(props.cardItem)
})
const isShowWebRender = computed(() => {
  // 是否使用前端的渲染
  return !isNewUavOperateItem.value || !renderImageSrc.value
})

function getCardName(cardItem: CardItemType) {
  return String(cardItem.type) === '81' ? '农用无人驾驶航空器操作证' : cardItem.cardName
}

const uploadPhotoHandle = () => {
  console.log('uploadPhotoHandle')
  // 加上卡片进度
  if (canUploadStatuds.includes(statusValue.value) && props.cardItem.isActive) {
    emit('upload')
  }
}

async function initCanvanseRenderImageUrl() {
  const cardItem = props.cardItem
  if (Number(cardItem?.type) === 37 || Number(cardItem?.type) === 81) {
    console.log('cardItem', cardItem)

    const url = cardItem?.license_image_url || (await getRenderOperatperCanvas(cardItem))
    canvasRenderImageUrl.value = url
  }
}
function resizeHandle() {
  if (!props.needCalc) {
    return
  }
  if (cardItemVm.value) {
    const { width } = cardItemVm.value.getBoundingClientRect()
    scaleValue.value = width / 517
  }
}

watch(
  () => props.cardItem,
  () => {
    initCanvanseRenderImageUrl()
  }
)
resizeInit(resizeHandle, true)
initCanvanseRenderImageUrl()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "card-wrap",
      style: _normalizeStyle({ height: __props.height }),
      ref_key: "cardItemVm",
      ref: cardItemVm
    }, [
      (__props.cardItem)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "card-item",
            style: _normalizeStyle({ transform: `scale(${scaleValue.value})` })
          }, [
            (_unref(isShowWebRender))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("img", {
                    width: "517",
                    height: "331",
                    src: 
              !__props.cardItem.isActive
                ? _unref(noActiveCard)
                : canvasRenderImageUrl.value || _unref(getBackgroundHandle)(__props.cardItem)
            
                  }, null, 8, _hoisted_2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["upload-photo-wrap", _unref(isNewUavOperateItem) && __props.cardItem.isActive ? 'diaoyun-operator-upload' : '']),
                    onClick: uploadPhotoHandle
                  }, [
                    (
                __props.cardItem.isActive &&
                __props.photo &&
                (_unref(isNewUavOperateItem) ? !__props.cardItem?.license_image_url : true)
              )
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "photo",
                          width: "126",
                          height: "157",
                          src: __props.photo
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true),
                    (__props.cardItem.isActive && (_unref(isShowCamera) || _unref(isShowReview)))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_unref(isShowCamera))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                width: 50,
                                height: 50,
                                src: _unref(cameraIcon)
                              }, null, 8, _hoisted_4))
                            : _createCommentVNode("", true),
                          (_unref(isShowReview))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                width: 52,
                                height: 30,
                                src: _unref(reviewIcon)
                              }, null, 8, _hoisted_5))
                            : _createCommentVNode("", true),
                          _hoisted_6
                        ], 64))
                      : _createCommentVNode("", true),
                    (!_unref(isDiaoyunOperator))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 2,
                          class: "horn",
                          src: _unref(getHorn)(__props.cardItem, __props.status)
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true),
                    (_unref(isShowNoUserPhoto))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 3,
                          width: "68",
                          height: "68",
                          class: "no-user-photo",
                          src: _unref(noUserPhoto)
                        }, null, 8, _hoisted_8))
                      : _createCommentVNode("", true)
                  ], 2),
                  (
              !__props.cardItem.isActive ||
              (!_unref(isNewUavOperateItem) && (__props.cardItem.isActive ? !_unref(isDiaoyunOperator) : true))
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(getCardName(__props.cardItem)), 1))
                    : _createCommentVNode("", true),
                  (__props.cardItem.isActive && !_unref(isNewUavOperateItem))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(__props.cardItem.name), 1),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(__props.cardItem.gender), 1),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(__props.cardItem.birthDay), 1),
                        _createElementVNode("div", _hoisted_13, _toDisplayString(__props.cardItem.createTime), 1),
                        (!_unref(isNewUavOperateItem))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(__props.cardItem.validityPeriod), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(__props.cardItem.issuingAuthority), 1),
                        _createElementVNode("div", {
                          class: "card-id",
                          style: _normalizeStyle({ color: _unref(getColorHandle)(__props.cardItem) })
                        }, _toDisplayString(__props.cardItem.id), 5)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "render-image",
                  style: _normalizeStyle({
              backgroundImage: 'url(' + _unref(renderImageSrc) + ')',
            })
                }, _hoisted_17, 4))
          ], 4))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}
}

})